<template>
  <div class="container-fluid springter-section">
    <lang-menu></lang-menu>
    <div class="row">
      <div class="col-12">
        <logo type="regular" @click.native="$ksvuefp.$emit('ksvuefp-nav-click', {nextIndex: 0})"></logo>
      </div>
    </div>
    <div class="section-content">
      <div class="row boxes section-content__wrapper">
        <div class="col-sm-12 col-md-6 col-lg-6 col-xl-4">
          <div class="section-content__left">
            <h2>{{ $t('section6Title') }}</h2>
            <p class="first-child">{{ $t('section6Text1') }}</p>
            <p>{{ $t('section6Text2') }}</p>       
          </div>
        </div>
        <div class="col-sm-12 col-md-6 col-lg-6 col-xl-4">
          <div class="section-content__center"> 
            <h2></h2>
            <p class="first-child">{{ $t('section6Text3') }}</p>  
            <p>{{ $t('section6Text4') }}</p>       
            <a @click.prevent="showModal = true" class="button medium hidden-xl-up" role="button" title="Contact">{{ $t('section6RequestDemo') }}</a>
          </div>
        </div>
        <div class="col-xl-4 hidden-lg-down">
          <div class="section-content__right ">
            <img src="../assets/img/01_small.png" alt="girl" />
            <div class="big-letter big-letter--right">+</div>
          </div>
          <a @click.prevent="showModal = true" class="button" role="button" title="Contact">{{ $t('section6RequestDemo') }}</a>
        </div>
        <contact-form v-if="showModal" @close="showModal = false"></contact-form>
      </div>
    </div>
    <arrow-button @click.native="$ksvuefp.$emit('ksvuefp-nav-click', {nextIndex: 6})"></arrow-button>
  </div>
</template>
<script>

import Logo from './shared/Logo';
import ArrowButton from './shared/ArrowButton';
import LangMenu from './shared/LangMenu';
import ContactForm from './shared/ContactForm';

export default {
  name: 'springter-section-6',
  components: {
    Logo,
    ArrowButton,
    LangMenu,
    ContactForm,
  },
  data() {
    return {
      showModal: false,
    };
  },
};
</script>

<style lang="scss" scoped>
  .big-letter{

    &--right{
      position: absolute;
      z-index: 2;
    }
  }

  .section-content{
    text-align: left;
    height: 100%;

    &__wrapper{
      height: 100%;

      @include mq('tablet-wide', 'max') {
        height: auto;
      }
    }

    p{
      margin-bottom: 15px;
      width: 85%;

      @include mq('tablet-wide', 'max') {
        margin-bottom: 20px;
        width: 100%;
      }
    }

    h2{
      height: $h--large;

      @include mq('phablet', 'max') {
          height: $h--small;
      }

      @include mqlandscape(){
          height: $h--small;
      }
    }

    &__left, &__center{
      padding-top: 12%;

      p.first-child{
        margin-top: 14%;
      }

      @include mq('tablet-wide', 'max') {
        padding-top: 0;

        p.first-child{
          margin-top: 10%;
        }
      }

      @include mq('tablet', 'max'){
        p.first-child{
          margin-top: 0;
        }
      }
    }

    &__center{
      .button.medium{
        margin-top: 5%;
        float: right;
        margin-right: 15%;

        @include mq('tablet-wide', 'max') {
          float: left;
        }

        @include mqlandscape(){
          float: left;
        }
      }

      @include mq('tablet', 'max'){
        h2{ display: none; }
      }
    }

    &__right{
      margin-top: -14%;

        img{
          position: absolute;
          left: 37%;
          max-width: 300px;
          z-index: 3;
          top: 6%;
        }

        .big-letter{
          position: absolute;
          z-index: 2;
          top: 15%;
          left: calc(50% - 146px);
        }
    }
  }

  .button{
    position: absolute;
    z-index: 4;
    top: 75%;
    left: calc(50% - 85px);
    
     @include mq('tablet-wide', 'max') {
       position: inherit;
     }
  }
  
  button.arrow{
    position: absolute;
    left: 50%;
    margin-left: -17px;
  }

  .boxes{
    @include mq('phone', 'max') {
      padding: 0;
    }
    @include mqlandscape(){
      padding: 0;
    }
  }

</style>


// WEBPACK FOOTER //
// src/components/SpringterSection6.vue